import React from 'react';
import '../css/Navbar.css';

const generateSquares = () => {
  const squares = [];
  for (let i = 0; i < 20; i++) {
    const size = Math.floor(Math.random() * 50) + 10; // Taille aléatoire entre 10 et 60px
    const top = Math.floor(Math.random() * 100) + '%';
    const left = Math.floor(Math.random() * 90) + '%';
    const opacity = Math.random();
    const backgroundColor = Math.random() > 0.5 ? '#FFFFFF' : '#FFD700'; // Couleur aléatoire entre blanc et doré
    squares.push(
      <div
        key={i}
        className="square"
        style={{
          width: `${size}px`,
          height: `${size}px`,
          top: top,
          left: left,
          opacity: opacity,
          backgroundColor: backgroundColor,
          animation: `fadeInOut ${Math.random() * 5 + 3}s ease-in-out infinite`,
        }}
      ></div>
    );
  }
  return squares;
};

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="squares-container">{generateSquares()}</div>
      <ul>
        <li><a href="#home">Accueil</a></li>
        <li><a href="#profile">Profil</a></li>
        <li><a href="#projects">Projets</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;